import { render } from "./button-shine.vue?vue&type=template&id=5b4812f4&scoped=true"
const script = {}

import "./button-shine.vue?vue&type=style&index=0&id=5b4812f4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4812f4"],['__file',"src/views/other/cssfx/components/button-shine.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4812f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4812f4', __exports__)) {
    console.log('reload')
    api.reload('5b4812f4', __exports__)
  }
  
  module.hot.accept("./button-shine.vue?vue&type=template&id=5b4812f4&scoped=true", () => {
    console.log('re-render')
    api.rerender('5b4812f4', render)
  })

}


export default __exports__